import { ReactNode } from "react";
import { tabProps } from "./helper";
import styled from "@emotion/styled";

const Container = styled("div")<{ fullHeight: boolean }>(({ fullHeight }) => ({
    height: fullHeight ? "100%" : undefined,
}));

interface TabPanelProps {
    name: string;
    currentTab: string;
    children?: ReactNode;
    fullHeight?: boolean;
}

/**
 * component to represent a tab-panel in the personal profile page,
 * wired with accessibility props etc.
 */
export function TabPanel({ children, currentTab, name, fullHeight = false }: TabPanelProps) {
    const { id: tabId, "aria-controls": panelId } = tabProps(name);

    return (
        <Container
            role="tabpanel"
            hidden={currentTab !== name}
            id={panelId}
            aria-labelledby={tabId}
            fullHeight={fullHeight}
        >
            {children}
        </Container>
    );
}
